import { IEmailTemplate } from "./interfaces/email-template";

export class EmailTemplate implements IEmailTemplate {
  constructor(emailTypeId: number) {
    this.emailTypeId = emailTypeId;
  }
  emailTemplateId: number;
  emailTypeId: number;
  from: string;
  to: string;
  subject: string;
  urlToLogo: string;
  salutation: string;
  content: string;
  complementaryClosing: string;
  name: string;
  urlToSignature: string;
  footer: string;
  index: number;
  isDeleted: boolean;

  isValid(): boolean { throw new Error("Not implemented"); }

  prepare(): void { throw new Error("Not implemented"); }
}
